export default __webpack_public_path__ + "static/media/justtechnews.f7986a5e.png";